import { useQuery } from '@tanstack/react-query';
import { TEAMS_BOT } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../../services/settingsApi';

const useTeamsBotIntegration = () => {
  const teamsBotQuery = useQuery([TEAMS_BOT], api.fetchTeamsBotSettings);

  return {
    isTeamsBotConnected: !!teamsBotQuery.data?.is_connected,
    isTeamsBotLoading: teamsBotQuery.isLoading,
    manifestUrl: teamsBotQuery.data?.manifest_url ?? '',
    appId: teamsBotQuery.data?.app_id ?? '',
    connectedWorkspaces:
      teamsBotQuery.data?.connected_workspaces.map((workspace) => ({
        tenantId: workspace.tenant_id,
        teamId: workspace.team_id,
      })) ?? [],
  };
};

export default useTeamsBotIntegration;
